(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buce-august-benefit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('buce-august-benefit')) {
  customElements.define('buce-august-benefit', class extends HTMLElement {
    connectedCallback() {
      this.count = this.cartCount();
      this.refresh = () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.update(), 180); };
      this.observer = new MutationObserver(() => {
        const count = this.cartCount();
        if (count !== this.count) { this.count = count; this.refresh(); }
      });
      this.observer.observe(document.body, { subtree: true, childList: true, characterData: true });
      window.addEventListener('pageshow', this.refresh);
      window.addEventListener('focus', this.refresh);
      document.addEventListener('cart:updated', this.refresh);
      document.addEventListener('cart:refresh', this.refresh);
    }
    cartCount() {
      return Array.from(document.querySelectorAll('[data-cart-count]')).map(el => el.textContent.trim()).join('|');
    }
    async update() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.querySelector('[data-benefit-content]');
        const current = this.querySelector('[data-benefit-content]');
        if (incoming && current && this.isConnected && incoming.innerHTML !== current.innerHTML) current.innerHTML = incoming.innerHTML;
      } catch (error) { if (error.name !== 'AbortError') this.dataset.refreshPending = 'true'; }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer.disconnect();
      if (this.controller) this.controller.abort();
      window.removeEventListener('pageshow', this.refresh);
      window.removeEventListener('focus', this.refresh);
      document.removeEventListener('cart:updated', this.refresh);
      document.removeEventListener('cart:refresh', this.refresh);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buce-r40-campaigns"] && !Shopify.designMode) return;
  try {
    
function buceR40Campaigns(){document.querySelectorAll('.buce-r40-campaigns__track').forEach(function(track){if(track.dataset.bound)return;track.dataset.bound='true';track.tabIndex=0;track.addEventListener('keydown',function(event){if(event.target!==track||!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();var slides=Array.from(track.children),at=slides.reduce(function(best,slide,i){return Math.abs(slide.offsetLeft-slides[0].offsetLeft-track.scrollLeft)<Math.abs(slides[best].offsetLeft-slides[0].offsetLeft-track.scrollLeft)?i:best;},0),next=Math.max(0,Math.min(slides.length-1,at+(event.key==='ArrowRight'?1:-1)));track.scrollTo({left:slides[next].offsetLeft-slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});});});}buceR40Campaigns();document.addEventListener('shopify:section:load',buceR40Campaigns);

  } catch(e) { console.error(e); }
})();
})();
